import { token } from '@atlaskit/tokens';

export const itemHighlightColor: 'var(--ds-background-neutral-subtle-hovered)' = token(
	'color.background.neutral.subtle.hovered',
);
